import type { Tag } from "@poi-planner/shared";

export function resolveTagNames(tagIds: string[], tags: Tag[]): string[] {
  const namesById = new Map(tags.map((tag) => [tag.id, tag.name]));
  return tagIds
    .map((tagId) => namesById.get(tagId))
    .filter((name): name is string => Boolean(name));
}
